import { render, staticRenderFns } from "./Frequiest.vue?vue&type=template&id=6b0d8a2c&scoped=true&"
import script from "./Frequiest.vue?vue&type=script&lang=js&"
export * from "./Frequiest.vue?vue&type=script&lang=js&"
import style0 from "./Frequiest.vue?vue&type=style&index=0&id=6b0d8a2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0d8a2c",
  null
  
)

export default component.exports